export const phoneNumberFormat = (phoneNumber: string) => {
  const cleaned = phoneNumber.replace(/[\s\-()]/g, '');

  if (cleaned.startsWith('8')) {
    return '+7' + cleaned.slice(1);
  }

  if (cleaned.startsWith('7') && !cleaned.startsWith('+7')) {
    return '+' + cleaned;
  }

  if (cleaned.startsWith('+7')) {
    return cleaned;
  }

  return cleaned;
};
